import styled, { keyframes } from 'styled-components';
import { devices } from "../data/constants";
import * as theme from "./Theme";


const slideIn = keyframes`   
    0% {
        transform: translateX(10px);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
`;

const appear = keyframes`   
    0% {
        opacity: 0;
        -webkit-opacity: 0;
        -ms-opacity: 0;
        -moz-opacity: 0;
    }
    100% {
        opacity: 1;
        -webkit-opacity: 1;
        -ms-opacity: 1;
        -moz-opacity: 1;
    }
`;


//  HAMBURGER MENU
export const MenuBarContainerStyled = styled.div`
    position: fixed;
    height: 80px;
    top: 0;
    right: 0;
    z-index: 90;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: transparent;
    width: 100%;
    color: ${({ theme }) => theme.colors.contrastText};
    font-family: ${({ theme }) => theme.colors.ff};
    transition: transform 0.3s ease;
    
    @media only screen and ${devices.md} {
        justify-content: space-between;
        background: ${({ theme }) => theme.colors.bg};
        transform: ${({ $hidden }) => $hidden ? 'translateY(-100%)' : 'translateY(0)'};
    }
`;

export const MenuContainerStyled = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 320px;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.cardBG};
    z-index: 100;
    color: ${({ theme }) => theme.colors.contrastText};
    transform: ${(props) => props.$open ? 'translateX(0)' : 'translateX(100%)'};
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: ${(props) => props.$open ? '-8px 0 30px rgba(0, 0, 0, 0.12)' : 'none'};
    border-left: 1px solid ${({ theme }) => theme.colors.borderColor};

    @media only screen and ${devices.md} {
        width: 100%;
        border-left: none;
    }
`;

export const MenuHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
    min-height: 80px;
`;

export const MenuHeaderTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.cardText};
    margin: 0;
`;

export const MenuCloseButton = styled.button`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    background: transparent;
    color: ${({ theme }) => theme.colors.subTextColor};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.colors.opacityColor};
        color: ${({ theme }) => theme.colors.cardText};
    }
`;


export const MenuButtonContainerStyled = styled.div`
    height: 40px;
    width: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    margin: 20px 30px;
    z-index: 90;
    border: solid 1px ${({ theme }) => theme.colors.borderColor};
    border-radius: 100%;
    opacity: ${(props) => props.$open ? 0 : 1};
    visibility: ${(props) => props.$open ? 'hidden' : 'visible'};
    transition: opacity 0.2s ease, visibility 0.2s ease;
`;

export const MenuButtonLineStyled = styled.div`
    height: 2px;
    width: 16px;
    background: ${({ theme }) => theme.colors.contrastText};
    transition: all 0.2s ease;
    -webkit-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
`;

export const MenuButtonLineTopStyled = styled(MenuButtonLineStyled)`
    transform: ${(props) => props.$open?'translate(4px, 0px) rotate(45deg)':"none"};
    -webkit-transform: ${(props) => props.$open?'translate(4px, 0px) rotate(45deg)':"none"};
    -ms-transform: ${(props) => props.$open?'translate(4px, 0px) rotate(45deg)':"none"};
    -moz-transform: ${(props) => props.$open?'translate(4px, 0px) rotate(45deg)':"none"};
    transform-origin: top left;
    margin-bottom: 3px;
`;

export const MenuButtonLineMiddleStyled = styled(MenuButtonLineStyled)`
    opacity: ${(props) => props.$open?0:1};
    transform: ${(props) => props.$open?'translateX(16px)':"none"};
    -webkit-transform: ${(props) => props.$open?'translateX(16px)':"none"};
    -ms-transform: ${(props) => props.$open?'translateX(16px)':"none"};
    -moz-transform: ${(props) => props.$open?'translateX(16px)':"none"};
`;

export const MenuButtonLineBottomStyled = styled(MenuButtonLineStyled)`
    transform: ${(props) => props.$open?'translate(2px, 1px) rotate(-45deg)':"none"};
    -webkit-transform: ${(props) => props.$open?'translate(2px, 1px) rotate(-45deg)':"none"};
    -ms-transform: ${(props) => props.$open?'translate(2px, 1px) rotate(-45deg)':"none"};
    -moz-transform: ${(props) => props.$open?'translate(2px, 1px) rotate(-45deg)':"none"};
    transform-origin: top left;
    margin-top: 3px;
`;


export const MenuItemContainerStyled = styled.div`
    opacity: 0;
    z-index: 90;
    font-family: ${theme.dark.colors.contrastText};
    animation: 1s ${appear} forwards;
    -webkit-animation: 1s ${appear} forwards;
    -ms-animation: 1s ${appear} forwards;
    -moz-animation: 1s ${appear} forwards;
`;

export const MenuOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 79;
    opacity: ${(props) => props.$open ? 1 : 0};
    visibility: ${(props) => props.$open ? 'visible' : 'hidden'};
    transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const MenuListStyled = styled.div`
    color: ${({ theme }) => theme.colors.contrastText};
    padding: 16px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;

export const MenuSection = styled.div`
    margin-bottom: 8px;
`;

export const MenuTitleStyled = styled.h2`
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.subTextColor};
    margin: 20px 0 8px 0;
    padding: 0 12px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
`;

export const MenuItemStyled = styled.div`
    font-family: ${({ theme }) => theme.colors.ff};
    font-size: 14px;
    font-weight: 500;
    padding: 14px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 10px;
    transition: background 0.15s ease;
    animation: 0.25s ${slideIn} forwards;
    animation-delay: ${props => props.$delay || '0s'};
    opacity: 0;
    color: ${({ theme }) => theme.colors.cardText};

    &:hover {
        background: ${({ theme }) => theme.colors.opacityColor};
    }
`;

export const MenuItemNameStyled = styled.span`
    margin-left: 12px;
`;


export const MenuItemIconStyled = styled.span`
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.opacityColor};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.activeColor};
`;

export const LogoStyled = styled.img`
    height: 40px;
    padding-left: 30px;
    z-index: 91;
    cursor: pointer;
    position: fixed;
    
    &.desktop-logo {
        @media only screen and ${devices.md} {
            display: none;
        }
    }
    
    &.mobile-logo {
        display: none;
        position: static;
        padding-left: 16px;
        
        @media only screen and ${devices.md} {
            display: block;
        }
    }
`;

export const NavFooterStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    background: ${({ theme }) => theme.colors.bg};
`;

export const NavFooterLabel = styled.span`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.subTextColor};
`;



export const ThemeToggleContainer = styled.div`
    height: 30px;
    width: 64px;
    position: relative;
    background: ${theme.dark.colors.cardText};
    border-radius: 30px;
    cursor: pointer;
    @media only screen and ${devices.md} {
        display: ${(props) => props.$mobile?'block':'none'};
        
    }
`;

export const ThemeToggleBall = styled.div`
    position: absolute;
    top: 1px;
    left: 1px;
    height: 28px;
    width: 28px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: ${({ theme }) => theme.colors.themeToggleTranslate};
    transition: all 0.5s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    will-change: transform;
    -webkit-font-smoothing: antialiased;
`;

export const ThemeIcons = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
`;

export const ThemeImage = styled.i`
    height: 20px;
    width: 20px;
    color: ${({ theme }) => theme.colors.themeToggleContrast};
`;